import { CHANGE_LOGO_COLOR } from './AppConstants'
export const changeLogoColor = (dispatch, params) => dispatch({type: CHANGE_LOGO_COLOR, payload: params})